export function isEmptyValue(v: any): boolean {
  return v === undefined || v === null;
}

export function isEmptyString(s: string): boolean {
  return s === undefined || s === null || s === '';
}

export function isEmptyArray(ar: any[]): boolean {
  return ar === undefined || ar === null || !ar.length;
}
